// Game icons from the spritesheet built by scripts/build-icons (see data/README.md).
import sheetUrl from './icons.png';
import sheet from './icons.json';
import { h, svg } from './util';

interface Sprite { x: number; y: number; fallback?: boolean }
const S = sheet as { cell: number; cols: number; width: number; height: number; sprites: Record<string, Sprite> };

export function hasIcon(cls: string | undefined): boolean {
  return !!cls && cls in S.sprites;
}

/** Inline HTML icon (empty span when unknown so layout stays stable). */
export function icon(cls: string | undefined, size = 18, title?: string): HTMLElement {
  const sp = cls ? S.sprites[cls] : undefined;
  const el = h('span', { class: 'icon', title: title ?? '' });
  el.style.width = el.style.height = `${size}px`;
  if (!sp) return el;
  const scale = size / S.cell;
  el.style.backgroundImage = `url(${sheetUrl})`;
  el.style.backgroundSize = `${S.width * scale}px ${S.height * scale}px`;
  el.style.backgroundPosition = `-${sp.x * scale}px -${sp.y * scale}px`;
  return el;
}

/** Icon for use inside the SVG graph: a nested <svg> viewport onto the sheet. */
export function iconSvg(cls: string | undefined, x: number, y: number, size = 18): SVGElement | null {
  const sp = cls ? S.sprites[cls] : undefined;
  if (!sp) return null;
  const el = svg('svg', { x, y, width: size, height: size, viewBox: `${sp.x} ${sp.y} ${S.cell} ${S.cell}`, class: 'gicon' });
  el.append(svg('image', { href: sheetUrl, x: 0, y: 0, width: S.width, height: S.height, preserveAspectRatio: 'none' }));
  return el;
}
